// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"styles_skeleton__2qnBh","shimmer":"styles_shimmer__2JQkm"};